<template>
  <el-checkbox-group v-model="childValue" @input="change">
    <el-checkbox :label="option.name" v-for="option in options" :disabled="option.disabled || disabled">{{ option.name }}</el-checkbox>
  </el-checkbox-group>
</template>
<style scoped>
  .el-checkbox {
    margin-right: 15px;
  }
  .el-checkbox+.el-checkbox {
    margin-left: 0px !important; 
  }
</style>
<script>
  /**
   * @param Array value 绑定值
   * @param String name 控件名
   * @param Boolean disabled 是否禁用
   * @param Array rules 表单验证规则
   * @param Array options 选项值
   * @param Number selectMin 最小选中数
   * @param Number selectMax 最大选中数
   */
  import modelConfig from '../../../../config/modelConfig'
  import _verify from '../../../../assets/js/verify'
  export default {
    props: ['value', 'name', 'disabled', 'rules', 'options', 'selectMin', 'selectMax', 'isNeed'],
    data() {
      return {
        childValue: null
      }
    },
    created() {
      this.initData()
      this.setRules()
    },
    methods: {
      initData() {
        if (this.value && this.value.length) {
          this.childValue = this.value
        } else if (this.value == null) {
          this.setDefaultValue()
        } else {
          this.childValue = []
        }
      },
      setRules() {
        if (this.rules) {
          if (this.isNeed) {
            if (this.selectMin) {
              this.rules[this.name].push({ validator: this.checkSelectMin })
            }
            if (this.selectMax) {
              this.rules[this.name].push({ validator: this.checkSelectMax })
            }
          }
        }
      },
      setDefaultValue() {
        this.childValue = []
        _(this.options).forEach((res) => {
          if (res.is_selected) {
            this.childValue.push(res.name)
          }
        })
        this.change(this.childValue)
      },
      checkSelectMin(rule, value, callback) {
        if (value.length < this.selectMin) {
          let text = ''
          if (this.selectMax) {
            text = `请勾选${this.selectMin}~${this.selectMax}个选项`
          } else {
            text = `请勾选不少于${this.selectMin}个选项`
          }
          callback(new Error(text))
        } else {
          callback()
        }
      },
      checkSelectMax(rule, value, callback) {
        if (this.selectMax && value.length > this.selectMax) {
          let text = ''
          if (this.selectMin) {
            text = `请勾选${this.selectMin}~${this.selectMax}个选项`
          } else {
            text = `最多只能勾选${this.selectMax}个选项`
          }
          callback(new Error(text))
        } else {
          callback()
        }
      },
      change(value) {
        this.$emit('input', value)
      }
    },
    watch: {
      'value'() {
        if (this.value != this.childValue) {
          this.initData()
        }
      }
    },
    mixins: [modelConfig]
  }
</script>



// WEBPACK FOOTER //
// honrayCheckbox.vue?f3a5f8a0